<template>
  <div class="content">
    <top-bar hide-top="true"/>
    <div class="container-fluid lecard-container" :class="{'admin': sender === 2}">
      <div :class="{'sel-chats': (dados.id_pedido || sender === 1)}">
        <div class="lecard-chats" v-if="sender == 2">
          <div class="lecard-chats-header d-flex align-items-center">
            <div class="mr-3" v-if="operator">
              <img :src="operator.url_imagem || 'https://img.freepik.com/vetores-premium/icone-do-robo-design-de-sinal-de-bot-conceito-de-simbolo-de-chatbot-servico-de-suporte-por-voz-bot-bot-de-suporte-on-line-estoque-ilustracao-vetorial_100456-34.jpg'" class="img-perfil">
            </div>
            <div>
              <h6 class="mb-0">{{ operator.nome_usuario }}</h6>
              <div class="small">{{ operator.nome_fantasia }}</div>
            </div>
            <div class="ml-auto">
              <button class="btn d-md-none" @click="buscarChats()">
                <i class="fa fa-ellipsis-v text-secondary"></i>
              </button>
            </div>
          </div>
          <div class="lecard-chats-search border-bottom">
            <div class="row no-gutters p-2">
              <div class="col-6 pr-1">
                <button class="btn btn-block btn-sm" :class="search.status === '1' ? 'btn-primary' : 'btn-outline-secondary'" @click="toggleChats('1')">
                  Em andamento <span class="new-message-balao" v-if="emAndamento">{{ emAndamento > 9 ? 9 : emAndamento }}</span>
                </button>
              </div>
              <div class="col-6 pl-1">
                <button class="btn btn-block btn-sm" :class="search.status === '2' ? 'btn-primary' : 'btn-outline-secondary'" @click="toggleChats('2')">
                  Finalizados
                </button>
              </div>
            </div>
            <div class="px-2 pb-2 d-flex justify-content-between align-items-center">
              <div class="position-relative w-100">
                <div>
                  <i class="fa fa-search small" style="position: absolute; top: 12px; left: 12px"></i>
                  <input id="atendiment" type="search" placeholder="Nome ou pedido" @search="searchChats()" @keyup="searchChats(true)"
                         v-model="search.termo" class="form-control border" style="padding-left: 34px"/>
                </div>
              </div>
              <div class="ml-2 text-nowrap">
                <button class="btn btn-outline-primary mr-1" @click="searchChats()" title="Pesquisar chats"><i class="fa fa-search"></i></button>
                <button class="btn btn-dark" @click="toggleChats('1')" title="Atualizar chats"><i class="fa fa-sync"></i></button>
              </div>
            </div>
          </div>
          <div class="lecard-chats-body">
            <div class="px-2 py-3 small" style="background-color: #FCD279" v-if="!connected">
              Certifique-se que está conectado á internet.
              <a href="javascript:" class="text-dark" @click="reloadPage()"><u>Reconectar</u></a>
            </div>
            <loading v-if="load" class="pt-4"/>
            <div v-else>
              <div class="lecard-chat" v-for="c in chats" :class="{'selected': dados.id_pedido == c.id_pedido}" :key="c.id_pedido">
                <router-link :to="'/chat/'+ c.id_pedido" class="lecard-chat-body text-dark text-decoration-none">
                  <h6 class="mb-1 text-ellipsis">#{{ c.id_contador }} - {{ c.nome_cliente }}</h6>
                  <p class="lecard-chat-msg text-ellipsis">{{ c.created_at | date }}</p>
                </router-link>
                <div class="d-flex align-items-center mr-3">
                  <div class="new-message-balao" v-if="c.new_messages > 0">{{ c.new_messages || 1 }}</div>
                  <chat-toggle class="ml-2" :dados="c" @finalizar="finalizarChat"/>
                </div>
              </div>
              <div class="d-flex justify-content-between align-items-center py-2"
                   v-if="search.page > 0 || chats.length >= limite">
                <button class="btn btn-sm small" @click="paginateChats(-1)" :disabled="search.page === 0"><i
                    class="fa fa-angle-left"></i> Voltar
                </button>
                <span class="small">Página: {{ search.page + 1 }}</span>
                <button class="btn btn-sm small" @click="paginateChats(1)" :disabled="chats.length < limite">Próximo
                  <i class="fa fa-angle-right"></i></button>
              </div>
            </div>
          </div>
        </div>
        <div class="lecard-conversa" :class="{'full': sender === 1}" v-if="dados.id_pedido">
          <div class="lecard-conversa-header">
            <div class="d-flex align-items-center" v-if="sender === 1">
              <img :src="dados.url_imagem || defaultAvatar" class="img-perfil">
              <div class="ml-3">
                <h6 class="mb-0">{{ dados.nome_fantasia }}</h6>
                <div class="small">Pedido {{ dados.id_contador }}</div>
              </div>
            </div>
            <div class="d-flex align-items-center" v-else>
              <div class="mr-3">
                <a href="javascript:" class="text-decoration-none text-dark" @click="closeChat()">
                  <i class="fa fa-arrow-left text-secondary small pr-2 d-md-none"></i>
                  <img :src="defaultAvatar" class="img-perfil">
                </a>
              </div>
              <a href="javascript:" class="text-decoration-none text-dark">
                <h6 class="mb-0">{{ dados.nome_cliente }}</h6>
                <div class="small">Pedido: {{ dados.id_contador }}</div>
              </a>
            </div>
          </div>
          <div id="conversaScroll" class="lecard-conversa-body">
            <loading v-if="loadMsg"/>
            <div v-else-if="messages.length">
              <div class="card border-0 mx-auto mb-3" style="border-radius: 16px">
                <div class="card-body text-center">
                  <div class="mb-2"><img :src="defaultAvatar" class="img-perfil"></div>
                  <h5 class="mb-0">Pedido: {{ dados.id_contador }}</h5>
                  <h6 class="small mb-0">{{ dados.nome_cliente }}</h6>
                  <div class="small" v-if="dados.telefone">{{ dados.telefone | phone }}</div>
                </div>
              </div>
              <div id="lecardMessages" class="lecard-container-balao">
                <div class="mb-1" :class="{'text-right': message.sender == sender}" v-for="(message, i) in messages"
                     :id="'msg' + i">
                  <chat-balao :sender="sender" :m="message" :key="i" v-if="message"/>
                </div>
              </div>
            </div>
          </div>
          <div class="lecard-conversa-footer bg-lecard">
            <list-emojis @addEmoji="addEmoji"/>
            <div class="lecard-conversa-campo">
              <button class="btn text-secondary btn-emoji mr-1" type="button" @click="toggleEmoji">
                <i class="far fa-smile"></i>
              </button>
              <textarea type="text" class="form-control" placeholder="Mensagem"
                id="campoMensagem"
                v-model="message"
                rows="1"
                @focus="$emit('toggleEmoji', true)"
                @keydown.enter.exact.prevent="prepareMsg()"
                @keydown.enter.shift.exact.prevent="addLineMessage"
                :disabled="loadMsg" maxlength="512">
              </textarea>
              <button class="btn btn-success btn-send ml-2" type="button" @click="enviarMensagem()" :disabled="loadMsg">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-send-2"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4.698 4.034l16.302 7.966l-16.302 7.966a.503 .503 0 0 1 -.546 -.124a.555 .555 0 0 1 -.12 -.568l2.468 -7.274l-2.468 -7.274a.555 .555 0 0 1 .12 -.568a.503 .503 0 0 1 .546 -.124" /><path d="M6.5 12h14.5" /></svg>
              </button>
            </div>
          </div>
        </div>
        <div class="lecard-welcome" v-else>
          <div class="text-center">
            <loading v-if="loadInicial"/>
            <div v-else>
              <div>
                <img src="../assets/bg-chat.png" alt="Logo" class="img-fluid" style="max-width: 312px">
              </div>
              <p class="mt-4" v-if="errMsg">{{errMsg}}</p>
              <div v-else>
                <h4 class="mt-4 text-secondary">LeCard Chat</h4>
                <p class="small">Chat de pedidos do LeCard Delivery</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "../components/loading";
import ChatBalao from "@/components/ChatBalao";
import TopBar from "@/components/TopBar";
import ChatToggle from "@/components/ChatToggle";
import ListEmojis from "@/components/ListEmojis";
import defaultAvatar from "@/assets/default-avatar.png";

export default {
  name: 'LeBot',
  components: {ListEmojis, ChatToggle,  TopBar, ChatBalao, Loading},

  data() {
    return {
      defaultAvatar,
      chats: [],
      chatsCache: [],
      emAndamento: 0,
      search: { page: 0, status: '1', termo: '' },
      limite: 30,
      load: true,
      loadMsg: true,
      loadInicial: true,

      dados: {},
      page: 0,
      messages: [],

      message: '',
      synctimeOut: null,
      connected: true,
      filter: false,
      departaments: [],
      offlineMsgs: [],
      sender: 0,

      isReady: true,
      errMsg: null
    }
  },

  methods: {
    loopChat() {
      clearInterval(this.synctimeOut);
      this.synctimeOut = setTimeout(() => {
        this.connected = this.$socket ? this.$socket.connected : false;
        this.$store.state.modalOflline = !this.connected;
        console.log('sync');

        if (sessionStorage.getItem('accessToken')) {
          this.buscarChats();
          this.loopChat();
        }
      }, 1000 * 60 * 3);
    },

    buscarChats(callback) {
      this.$http.get('chat/admin', { params: this.search })
        .then(response => {
          this.load = false;
          const chats = response.data && response.data.length ? response.data : [];

          this.chatsCache = chats.map(opt => { return { ...opt,
            _nome_cliente: opt.nome_cliente.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase()
          }});

          this.chats = this.chatsCache;

          if (callback) {
            callback(true);
          }

        }, res => {
          this.load = false;
          console.log(res);

          if (callback) {
            callback(false);
          }

          if (res.status === 401) {
            sessionStorage.clear();
            window.location.href = '/';
          }
        });
    },

    buscarPedido(id, callback) {
      this.$http.get(`chat/pedido?id_pedido=${id}`)
        .then(response => {
          this.load = false;

          if (response.data && response.data.id_pedido) {
            this.dados = response.data;

            if (this.dados.id_chat) {
              this.getMessages(true);

            } else {
              this.loadMsg = false;
            }

            setTimeout(() => {
              console.log('sync');
              this.buscarPedido(id);
            }, 1000 * 60 * 3);

            if (callback) callback(true);

          } else {
            if (callback) callback(false);
            this.dados = {};
            this.errMsg = 'Não foi possível carregar as informações deste chat.';
          }

        }, res => {
          this.load = false;
          if (callback) callback(false);

          if (res.status === 404) {
            this.dados = {};
            this.errMsg = 'O chat deste pedido não está disponível';
          }
        });
    },

    searchChats(live) {
      const termo = this.search.termo.trim() ? this.search.termo.trim().toLowerCase() : null;

      if (this.search.status === '1') {
        if (termo) {
          if (isNaN(termo)) {
            this.chats = this.chatsCache.filter(c => c._nome_cliente.includes(termo));

          } else {
            this.chats = this.chatsCache.filter(c => c.id_contador.toString().includes(termo));
          }

        } else {
          this.chats = this.chatsCache;
        }

      } else if (!live) {
        this.search.termo = this.search.termo.trim();
        this.filterChats();
      }
    },

    toggleChats(status) {
      this.emAndamento = 0;
      this.search.status = status;
      this.search.termo = '';
      this.filterChats();
    },

    filterChats() {
      this.load = true;
      this.chats = [];
      this.search.page = 0;
      this.dados = {};
      this.buscarChats();

      if (this.$route.name !== 'Chats') {
        this.$router.push('/');
      }
    },

    toggleEmoji() {
      if (!this.loadMsg) {
        this.$emit('toggleEmoji');
      }
    },

    paginateChats(index) {
      if ((this.search.page + index) >= 0) {
        this.load = true;
        this.search.page += index;
        this.buscarChats();
      }
    },

    selChat(id, load) {
      this.messages = [];
      this.page = 0;

      if (id) {
        let chat = this.chats.find(c => c.id_pedido == id);

        if (chat) {
          this.dados = chat || { id_pedido: id };
          chat.new_messages = 0;
          this.notification();
          this.getMessages(load, () => {
            this.$helpers.focusElement('campoMensagem');
          });
        }

      } else {
        this.dados = { };
      }
    },

    getMessages(load, callback) {
      const id = this.dados.id_chat;

      if (!id) {
        this.loadMsg = false;
        this.load = false;
        return;
      }

      if (load) {
        this.loadMsg = true;
      }

      const search = { id_chat: id };
      let url = this.sender === 1 ? `chat/pedido/mensagens` : `chat/admin/mensagens`;

      this.$http.get(url, { params: search }).then(response => {
        if (response.data) {
          const messages = response.data;
          this.messages.unshift(...messages);
        }

        this.loadMsg = false;
        this.load = false;

        this.$nextTick(() => {
          this.$helpers.scrollView(`msg${this.messages.length - 1}`);
          if (callback) callback();
        });

      }, res => {
        this.loadMsg = false;
        this.load = false;
        this.$swal(res.data.msg || "Não foi possível buscar as mensagens deste chats!");
      });
    },

    prepareMsg() {
      if (this.$helpers.isMobile()) {
        this.addLineMessage();

      } else {
        this.enviarMensagem();
      }
    },

    enviarMensagem(dataMessage, callback) {
      if (!dataMessage) {
        let mensagem = this.message.trim();

        if (!mensagem || !this.dados.id_pedido) {
          return;
        }

        const date = new Date();

        dataMessage = {
          mensagem,
          id_pedido: this.dados.id_pedido,
          id_chat: this.dados.id_chat,
          sender: this.sender,
          session: this.session,
          send_at: this.$dayjs(date).format('HH:mm'),
          created_at: null,
          id_mensagem: null
        }

        this.message = "";
        this.$nextTick(() => {
          this.$helpers.scrollView(`msg${this.messages.length - 1}`);
        });

        this.messages.push(dataMessage);
      }

      let url = this.sender === 1 ? 'chat/pedido/mensagem' : 'chat/admin/mensagem';
      const errorMsg = "Não foi possível enviar esta mensagem";

      this.$http.post(url, dataMessage).then(res => {
        if (res.data && res.data.id_mensagem) {
          dataMessage.id_mensagem = res.data.id_mensagem;
          dataMessage.id_chat = res.data.id_chat;

          if (!this.dados.id_chat) {
            this.dados.id_chat = dataMessage.id_chat;
          }

          if (callback) {
            callback(dataMessage);
          }

        } else {
          this.$swal(errorMsg);
          this.getMessages(true);
          this.addTempMessage(dataMessage);
        }

      }, res => {
        this.$swal(res.data && res.data != "" ? res.data : errorMsg);
        this.addTempMessage(dataMessage);
      });
    },

    addLineMessage() {
      this.message += '\n';
      const campoMsg = document.getElementById('campoMensagem');

      if (campoMsg) {
        document.getElementById('campoMensagem').scrollTop = campoMsg.scrollHeight;
      }
    },

    addEmoji(e) {
      this.message += e;
    },

    finalizarChat(id_chat) {
      if (this.loadMsg || this.sender === 1) {
        return;
      }

      const dados = { id_chat, status: '0' }
      this.$http.post('chat/admin/dados', dados).then(res => {
        if (res.data.success) {
          this.chatsCache = this.chatsCache.filter(c => c.id_chat !== id_chat);
          this.chats = this.chats.filter(c => c.id_chat !== id_chat);

          if (id_chat == this.dados.id_chat) {
            this.closeChat();
          }
        }

      }, res => {
        this.$swal(res.data ? res.data : 'Erro temporário');
      });
    },

    moveItem(chat) {
      const element = chat;
      const index = this.chats.findIndex(c => c.id_chat === chat.id_chat);

      if (index >= 0) {
        this.chats.splice(index, 1);
        this.chats.splice(0, 0, element);
      }
    },

    notification() {
      const count = this.chats.reduce((acc, obj) => { return acc + (obj.new_messages || 0) }, 0);
      document.title = count > 0 ? `(${count}) LeCard Chats` : 'LeCard Chats';
    },

    reloadPage() {
      window.location.reload();
    },

    checkNotification() {
      if (this.canPlay) {
        this.playNotification();
        this.$swal({
          text: "Nova solicitação de atendimento",
          buttons: ["Voltar", "Visualizar!"],
          dangerMode: true
        }).then((res) => {
          if (res) {
            this.pauseNotification();

            if (this.$route.params.id != chat.id) {
              this.$router.push('/chat/' + chat.id);

            } else {
              this.selChat(chat.id, true);
            }
          }
        });
      }
    },

    sendOffilineMsgs() {
      if (this.offlineMsgs.length) {
        this.enviarMensagem(this.offlineMsgs[0], () => {
          this.offlineMsgs.splice(0, 1);
          this.sendOffilineMsgs();
        });

      } else if (this.dados.id) {
        this.selChat(this.dados.id);
      }
    },

    closeChat() {
      if (this.$route.name !== 'Lebot') {
        this.$router.push('/');

      } else {
        this.dados = { id: null }
      }
    },

    checkOffline() {
      this.$swal({
        text: "Algumas mensagens não foram enviadas. Ao trocar de conversa você poderá perde-las.",
        buttons: ["Aguardar", "Sair"],
        dangerMode: true
      }).then((res => {
        if (res) {
          this.offlineMsgs = [];
          this.dados = {id: null}
        }
      }));
    },

    updateMensagem(message) {
      const messagemEncontrada = this.messages.find(e => e.id_mensagem == message.id_mensagem);

      if (!messagemEncontrada) {
        this.messages.push(message);
      }
    },

    addTempMessage(message) {
      this.messages.push(message);
      this.offlineMsgs.push(message);
    },

    joinPedidoRoom() {
      if (this.$route.name === 'ChatPedido') {
        this.$socket.emit('chat_join_message', this.dados.id_pedido);
      }
    },

    joinEmpresaRoom() {
      if (this.sender === 2 && this.operator && this.operator.id_empresa) {
        this.$socket.emit('chat_join_empresa', this.operator.id_empresa);
      }
    }
  },

  mounted() {
    if (this.$route.name === 'ChatPedido') {
      this.sender = 1;
      this.buscarPedido(sessionStorage.getItem('pedido'), (res) => {
        this.loadInicial = false;

        if (res) {
          this.joinPedidoRoom();
        }
      });

    } else {
      this.sender = 2;
      this.joinEmpresaRoom();
      this.buscarChats((res) => {
        this.loadInicial = false;

        if (res && this.$route.name === 'ChatAdmin') {
          this.selChat(this.$route.params.id, true);
        }

        window.parent.postMessage(this.chats.filter(c => c.new_messages > 0).map(c => c.id_chat), "*");
      });

      this.loopChat();
    }

    setTimeout(() => {
      this.isReady = true;
    }, 20000);
  },

  computed: {
    operator() {
      return this.$store.state.dataUser;
    },

    session() {
      return this.$store.state.session;
    },

    canPlay() {
      return this.$store.state.canPlay;
    }
  },

  sockets: {
    connect() {
      if (!this.isReady) {
        return;
      }

      this.connected = true;
      this.joinPedidoRoom(this.dados.id_pedido);
      this.joinEmpresaRoom();

      if (this.$route.name === 'ChatPedido') {
        this.sendOffilineMsgs();

      } else if (this.$route.name === 'Chats' || this.$route.name === 'ChatAdmin') {
        this.buscarChats(() => {
          this.sendOffilineMsgs();
        });
      }
    },

    disconnect() {
      this.connected = false;
    },

    chat_message(data) {
      if (this.sender === 1) {
        if (data.session !== this.session) {
          this.updateMensagem(data);

          this.$nextTick(() => {
            this.$helpers.scrollView(`msg${this.messages.length - 1}`);
          });
        }

        return;
      }

      const chat = this.chats.find(c => c.id_chat == data.id_chat);

      if (chat) {
        this.moveItem(chat);

        if (this.dados.id_chat !== chat.id_chat) {
          chat.new_messages = (parseInt(chat.new_messages)) + 1;
          this.notification();

        } else if (this.session !== data.session) {
          this.messages.push(data);
          this.$nextTick(() => {
            this.$helpers.scrollView(`msg${this.messages.length - 1}`);
          });
        }

      } else if (this.search.status === '1') {
        this.buscarChats();

      } else if (data.sender === 1) {
        this.emAndamento++;
      }
    }
  },

  filters: {
    tel(value) {
      return value ? value.toString().replace(/[^0-9]/g, '')
          .replace(/(\d{2})(\d{2})(\d{5})(\d{4})/, '+$1 $2 $3-$4') : '';
    },

    date(value) {
      const date = value ? new Date(value) : null;

      if (date) {
        const month = `0${date.getMonth() + 1}`.slice(-2);
        const day = `0${date.getDate()}`.slice(-2);
        const hour = `0${date.getHours()}`.slice(-2);
        const minutes = `0${date.getMinutes()}`.slice(-2);
        return `${day}/${month}/${date.getFullYear()} - ${hour}:${minutes}`
      }

      return '';
    },

    phone(phone) {
      if (phone) {
        if (phone.length === 10) {
          return phone.replace(/[^0-9]/g, '')
              .replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');

        } else if (phone.length === 11) {
          return phone.replace(/[^0-9]/g, '')
              .replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
        }
      }

      return phone
    }
  },

  beforeDestroy() {
    clearInterval(this.synctimeOut);
  },

  beforeRouteLeave(to, from, next) {
    this.pauseNotification();

    if (this.offlineMsgs.length) {
      this.checkOffline();
      next(false);

    } else {
      next();
    }
  },

  watch: {
    $route(to, from) {
      if (this.sender === 2) {
        this.message = '';

        if (this.offlineMsgs.length) {
          this.checkOffline();

        } else {
          this.selChat(to.params.id, true);
        }
      }
    }
  }
}
</script>

<style scoped>
.lecard-container {
  width: 100%;
  position: relative;
  padding: 0;
}

.lecard-chats {
  position: relative;
  background-color: #ffffff;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  border-right: 1px solid #dee2e6;
  padding: 0;
  width: 100%;
  left: 0;
}

.lecard-chats-header, .lecard-conversa-header {
  position: absolute;
  width: 100%;
  top: 0;
  z-index: 2;
  background-color: var(--light);
  padding: 8px 15px;
}

.lecard-chats-search {
  position: absolute;
  width: 100%;
  top: 56px;
  left: 0;
  z-index: 2;
  background-color: #ffffff;
}

.lecard-chats-body {
  position: absolute;
  width: 100%;
  top: 150px;
  left: 0;
  bottom: 0;
  padding-bottom: 12px;
  z-index: 1;
  overflow: auto;
}

.lecard-conversa {
  width: 100%;
  top: 0;
  right: 0;
  background-color: #EFEAE2;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;
  position: fixed;
}

.lecard-conversa-header {
  position: fixed;
  width: 100%;
  right: 0;
}

.lecard-conversa-body {
  padding: 72px 15px;
}

.lecard-conversa-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  right: 0;
  padding: 8px 6px;
  z-index: 1;
}

.lecard-conversa-campo {
  display: flex;
  position: relative;
  align-items: center;
}

.lecard-conversa-campo .form-control {
  padding: 12px 12px 12px 44px;
  font-size: 14px;
  resize: none;
  border-radius: 22px;
  border: none;
}

.btn-emoji {
  position: absolute;
  outline: none;
  left: 4px;
  top: 5px;
}

.btn-emoji:focus {
  box-shadow: none;
  font-size: 18px;
}

.btn-send {
  border-radius: 50%;
  width: 48px;
  height: 44px;
}

.lecard-welcome {
  position: absolute;
  top: 0;
  right: 0;
  background-color: var(--light);
  width: 100%;
  height: 100vh;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.new-message-balao {
  display: inline-block;
  background-color: var(--primary);
  border-radius: 50%;
  color: #fff;
  font-size: 14px;
  line-height: 14px;
  font-weight: 500;
  padding: 1px 5px 1px;
}

.lecard-chat {
  border-bottom: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.lecard-chat-body {
  width: calc(100% - 50px);
  padding: 14px;
}

.lecard-chat-msg {
  font-size: 12px;
  line-height: 14px;
  margin-bottom: 0;
}

.lecard-chat .bold h6, .lecard-chat .bold .lecard-chat-msg {
  font-weight: 600 !important;
}

.lecard-chat:hover, .lecard-chat.selected {
  background-color: var(--light);
}

.img-perfil {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

@media (min-width: 768px) {
  .admin .lecard-chats {
    width: 33.33%;
  }

  .admin .lecard-conversa, .admin .lecard-conversa-header, .admin .lecard-conversa-footer, .admin .lecard-welcome {
    width: 66.66%;
  }
}

@media (max-width: 767px) {
  .sel-chats .lecard-chats {
    display: none;
  }

  .lecard-chats, .lecard-chats-header, .lecard-conversa-header, .lecard-conversa, .lecard-conversa-footer {
    border-right: none;
  }

  .lecard-chats-search {
   padding-top: 56px;
  }

  .lecard-chats-search, .lecard-chats-body {
    height: auto;
    border: none;
    overflow: visible;
    position: static;
  }

  .lecard-conversa-body {
    padding: 72px 15px 86px;
  }

  .lecard-conversa-footer {
    padding: 11px 8px 20px;
  }

  .lecard-conversa, .lecard-welcome {
    display: none;
  }

  .sel-chats .lecard-conversa, .sel-chats, .lecard-welcome {
    display: block;
  }

  .admin .lecard-welcome {
    display: none;
  }

  .lecard-conversa-footer .form-control {
    font-size: 16px;
  }

  .lecard-container {
    box-shadow: none;
    border: none;
    margin: 0;
    max-width: none;
  }
}
</style>
